export default {"src":"/_next/static/media/call.e4452d60.svg","height":43,"width":42,"blurWidth":0,"blurHeight":0};